import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectiveModule } from '.';

@NgModule({
  imports: [CommonModule, DirectiveModule],
  exports: [DirectiveModule]
})
export class SharedModule { }
